import { BrowserRouter, Routes, Route } from "react-router-dom";
import Menu from "./Menu";
import { FleetMetrics } from "../../pages/fleet_metrics";
import { ChargerMetrics } from "../../pages/charger_metrics";
import OcppMessages from "../../pages/ocpp_messages";
import { Troubleshoot } from "../../pages/logs_download";
import PrivateRoute from "./PrivateRoute";
import Login from "../../pages/Auth/Login";
import EvSummary from "../../pages/charger_details/EvSummary";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <PrivateRoute>
              <Menu />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<FleetMetrics />} />
          <Route path="/charger" element={<ChargerMetrics />} />
          <Route path="/summary" element={<EvSummary />} />
          <Route path="/ocpp" element={<OcppMessages />} />
          <Route path="/troubleshoot" element={<Troubleshoot />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
